export const authTranslations = {
  ru: {
    'auth.login.title': 'MH BankStatement',
    'auth.login.subtitle': 'Операционное рабочее место обработки платежек',
    'auth.login.emailLabel': 'Email',
    'auth.login.passwordLabel': 'Пароль',
    'auth.login.submit': 'Войти',
    'auth.login.errorFallback': 'Ошибка входа',
    'auth.context.preparing': 'Подготавливаем рабочий контекст…',
    'auth.context.applying': 'Применяем контекст…',
    'auth.context.loadError': 'Не удалось загрузить доступные organization/outlet контексты.',
    'auth.context.autoSelectError': 'Не удалось автоматически выбрать контекст. Выберите вручную.',
    'auth.context.setError': 'Не удалось установить контекст.',
    'auth.context.title': 'Выберите рабочий контекст',
    'auth.context.subtitle': 'После выбора доступны рабочие разделы в рамках вашей области доступа.',
    'auth.context.organizationLabel': 'Organization',
    'auth.context.outletLabel': 'Outlet',
    'auth.context.orgWideHint': 'Для этой организации доступен org-wide режим без выбора Outlet.',
    'auth.context.continue': 'Продолжить',
    'auth.invite.errorTitle': 'Принятие инвайта',
    'auth.invite.acceptTitle': 'Принять приглашение',
    'auth.invite.tokenMissingError': 'Ссылка на инвайт недействительна: токен отсутствует.',
    'auth.invite.goToLogin': 'Перейти ко входу',
    'auth.invite.checking': 'Проверяем инвайт…',
    'auth.invite.invalidOrExpired': 'Инвайт недействителен или истёк.',
    'auth.invite.rolePrefix': 'Роль:',
    'auth.invite.expiresAt': 'Инвайт действует до {date}',
    'auth.invite.displayNameLabel': 'Display name (опционально)',
    'auth.invite.passwordLabel': 'Пароль',
    'auth.invite.confirmPasswordLabel': 'Повторите пароль',
    'auth.invite.submit': 'Принять инвайт',
    'auth.invite.errorTokenMissing': 'Invite token отсутствует.',
    'auth.invite.errorPasswordRequired': 'Введите пароль.',
    'auth.invite.errorPasswordMismatch': 'Пароли не совпадают.',
    'auth.invite.successTitle': 'Инвайт принят',
    'auth.invite.successBody': 'Учётная запись создана, но вы ещё не вошли в систему. Войдите с email из приглашения и паролем, который только что задали.',
    'auth.invite.errorAcceptFailed': 'Не удалось принять инвайт.',
    'auth.guard.checkingContext': 'Проверяем рабочий контекст…',
    'auth.guard.checkingPermissions': 'Проверяем права доступа…',
    'auth.guard.accessDenied.title': 'Нет доступа',
    'auth.guard.accessDenied.message': 'У вашей роли нет прав для этого раздела или действия.',
    'auth.guard.accessDenied.contactAdmin': 'Если доступ нужен для работы, обратитесь к администратору организации.',
    'auth.guard.megaRoleOnly': 'Раздел доступен только MegaAdmin и MegaManager.',
    'auth.guard.outletContextRequired.title': 'Выберите организацию и Outlet',
    'auth.guard.outletContextRequired.message': 'Для операционных разделов MegaAdmin и MegaManager должны выбрать явный рабочий контекст: organization + Outlet. Это защищает от случайного просмотра агрегированных данных по всем Outlet.',
    'auth.guard.outletContextRequired.cta': 'Выбрать контекст',
  },
  en: {
    'auth.login.title': 'MH BankStatement',
    'auth.login.subtitle': 'Operational workspace for payment processing',
    'auth.login.emailLabel': 'Email',
    'auth.login.passwordLabel': 'Password',
    'auth.login.submit': 'Sign in',
    'auth.login.errorFallback': 'Sign-in failed',
    'auth.context.preparing': 'Preparing your workspace context…',
    'auth.context.applying': 'Applying context…',
    'auth.context.loadError': 'Failed to load available organization/outlet contexts.',
    'auth.context.autoSelectError': 'Could not select context automatically. Please choose manually.',
    'auth.context.setError': 'Failed to set context.',
    'auth.context.title': 'Select workspace context',
    'auth.context.subtitle': 'After selection, workspace sections within your access scope become available.',
    'auth.context.organizationLabel': 'Organization',
    'auth.context.outletLabel': 'Outlet',
    'auth.context.orgWideHint': 'This organization supports org-wide mode without selecting an outlet.',
    'auth.context.continue': 'Continue',
    'auth.invite.errorTitle': 'Accept invite',
    'auth.invite.acceptTitle': 'Accept invitation',
    'auth.invite.tokenMissingError': 'Invalid invite link: token is missing.',
    'auth.invite.goToLogin': 'Go to sign in',
    'auth.invite.checking': 'Validating invite…',
    'auth.invite.invalidOrExpired': 'Invite is invalid or has expired.',
    'auth.invite.rolePrefix': 'Role:',
    'auth.invite.expiresAt': 'Invite expires on {date}',
    'auth.invite.displayNameLabel': 'Display name (optional)',
    'auth.invite.passwordLabel': 'Password',
    'auth.invite.confirmPasswordLabel': 'Confirm password',
    'auth.invite.submit': 'Accept invite',
    'auth.invite.errorTokenMissing': 'Invite token is missing.',
    'auth.invite.errorPasswordRequired': 'Enter a password.',
    'auth.invite.errorPasswordMismatch': 'Passwords do not match.',
    'auth.invite.successTitle': 'Invite accepted',
    'auth.invite.successBody': 'Your account is ready, but you are not signed in yet. Sign in with the invite email and the password you just set.',
    'auth.invite.errorAcceptFailed': 'Failed to accept invite.',
    'auth.guard.checkingContext': 'Checking workspace context…',
    'auth.guard.checkingPermissions': 'Checking access permissions…',
    'auth.guard.accessDenied.title': 'Access denied',
    'auth.guard.accessDenied.message': 'Your role does not have permission for this section or action.',
    'auth.guard.accessDenied.contactAdmin': 'If you need access for your work, contact your organization administrator.',
    'auth.guard.megaRoleOnly': 'This section is available only to MegaAdmin and MegaManager.',
    'auth.guard.outletContextRequired.title': 'Select organization and Outlet',
    'auth.guard.outletContextRequired.message': 'Operational sections require an explicit organization + Outlet context for MegaAdmin and MegaManager. This prevents accidental all-Outlet operational views.',
    'auth.guard.outletContextRequired.cta': 'Select context',
  },
  id: {
    'auth.login.title': 'MH BankStatement',
    'auth.login.subtitle': 'Ruang kerja operasional untuk pemrosesan pembayaran',
    'auth.login.emailLabel': 'Email',
    'auth.login.passwordLabel': 'Kata sandi',
    'auth.login.submit': 'Masuk',
    'auth.login.errorFallback': 'Gagal masuk',
    'auth.context.preparing': 'Menyiapkan konteks ruang kerja…',
    'auth.context.applying': 'Menerapkan konteks…',
    'auth.context.loadError': 'Gagal memuat konteks organization/outlet yang tersedia.',
    'auth.context.autoSelectError': 'Tidak dapat memilih konteks secara otomatis. Pilih secara manual.',
    'auth.context.setError': 'Gagal menetapkan konteks.',
    'auth.context.title': 'Pilih konteks ruang kerja',
    'auth.context.subtitle': 'Setelah dipilih, bagian ruang kerja dalam cakupan akses Anda akan tersedia.',
    'auth.context.organizationLabel': 'Organization',
    'auth.context.outletLabel': 'Outlet',
    'auth.context.orgWideHint': 'Organisasi ini mendukung mode org-wide tanpa memilih outlet.',
    'auth.context.continue': 'Lanjutkan',
    'auth.invite.errorTitle': 'Menerima undangan',
    'auth.invite.acceptTitle': 'Terima undangan',
    'auth.invite.tokenMissingError': 'Tautan undangan tidak valid: token tidak ada.',
    'auth.invite.goToLogin': 'Ke halaman masuk',
    'auth.invite.checking': 'Memverifikasi undangan…',
    'auth.invite.invalidOrExpired': 'Undangan tidak valid atau sudah kedaluwarsa.',
    'auth.invite.rolePrefix': 'Peran:',
    'auth.invite.expiresAt': 'Undangan berlaku hingga {date}',
    'auth.invite.displayNameLabel': 'Display name (opsional)',
    'auth.invite.passwordLabel': 'Kata sandi',
    'auth.invite.confirmPasswordLabel': 'Ulangi kata sandi',
    'auth.invite.submit': 'Terima undangan',
    'auth.invite.errorTokenMissing': 'Token undangan tidak ada.',
    'auth.invite.errorPasswordRequired': 'Masukkan kata sandi.',
    'auth.invite.errorPasswordMismatch': 'Kata sandi tidak cocok.',
    'auth.invite.successTitle': 'Undangan diterima',
    'auth.invite.successBody': 'Akun sudah dibuat, tetapi Anda belum masuk. Masuk dengan email undangan dan kata sandi yang baru saja Anda buat.',
    'auth.invite.errorAcceptFailed': 'Gagal menerima undangan.',
    'auth.guard.checkingContext': 'Memeriksa konteks ruang kerja…',
    'auth.guard.checkingPermissions': 'Memeriksa hak akses…',
    'auth.guard.accessDenied.title': 'Akses ditolak',
    'auth.guard.accessDenied.message': 'Peran Anda tidak memiliki izin untuk bagian atau tindakan ini.',
    'auth.guard.accessDenied.contactAdmin': 'Jika akses diperlukan untuk pekerjaan Anda, hubungi administrator organisasi.',
    'auth.guard.megaRoleOnly': 'Bagian ini hanya tersedia untuk MegaAdmin dan MegaManager.',
    'auth.guard.outletContextRequired.title': 'Pilih organization dan Outlet',
    'auth.guard.outletContextRequired.message': 'Bagian operasional memerlukan konteks organization + Outlet yang eksplisit untuk MegaAdmin dan MegaManager. Ini mencegah tampilan operasional semua Outlet secara tidak sengaja.',
    'auth.guard.outletContextRequired.cta': 'Pilih konteks',
  },
} as const;
